import React ,{useEffect,useState}from 'react';

import './About.css';

const About = props => {
  const [info, setInfo]= useState();
  const [error, setError]= useState();
   
useEffect(()=>{
    window.scrollTo(0, 0);   
    const sendRequest = async() =>{
      const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/info/');
      if (await !response.ok){
        setError(response.statusText);
       }else{
       const responseData= await response.json();
       setInfo(responseData);
      }
    };
    sendRequest();
},[]);

  return <div className="mainRecommenderDiv">
      <h1>About</h1>
      <div className="aboutDiv">
        GeoLOD Recommender is an online catalog of Linked Data Spatial Datasets and Classes and an on-the-fly class recommendender for user defined SPARQL Endpoints, shapefiles and GeoJSON files.
       <br/> Visitors can search for availiable datasets and classes in the Web of Data, view their details and get recommendations about other datasets and classes that may contain related instances, so as to be used for Link Discovery.
        <br/>The catalog parses datasets and classes from <a href="https://lod-cloud.net/" target="new">LOD</a> and <a href="https://datahub.io/" target="new">datahub</a> that contain georeferenced point instances using one of the following geo-ontologies:
        <ul> 
          <li> <a href="https://www.w3.org/2003/01/geo/" target="new">W3C Basic Geo</a></li>
          <li> <a href="https://www.w3.org/2005/Incubator/geo/XGR-geo-20071023/" target="new">GeoRSS</a></li>
          <li> <a href="http://geovocab.org/spatial" target="new">NeoGeo</a></li>
          <li> <a href="http://www.w3c.it/talks/2010/smau2010/examples/GeoNames%20Ontology%20-%20Geo%20Semantic%20Web.html#:~:text=The%20GeoNames%20Ontology%20makes%20it,describe%20the%20relation%20between%20toponyms." target="new">Geonames</a></li>
          <li> <a href="https://www.ogc.org/standards/geosparql" target="new">GeoSPARQL</a></li>
        </ul> 
        Dataset descriptions can be exported in <a href="http://83.212.121.124/schemas/geovoid" target="new">GeoVoID</a>, a vocabulary that extents VoID to describe spatial metadata.
        The on-the-fly recommender supports point sets georeferenced in the WGS 84 Coordinate Reference System (CRS). For user-defined SPARQL Endpoints only the W3C Basic Geo geo-ontology is currently supported. 
        <br/>Visitors can also export <a href="http://silkframework.org/" target="new">SILK LSL</a> and <a href="https://github.com/dice-group/LIMES" target="new">LIMES XML</a> configuration files for two recommended classes.    
        <br/>The catalog and the recommendations are updated on a monthly basis.
        <br/>You can find more information about the recommendation methodology at the <a href="#pubs">Related Publications</a> section.
       
      </div>
      <br/>
      
      <h3 >Statistics & Info</h3>
      <hr className="abouthr"/>
      {info &&
      <div className="aboutDiv">
        <p><i>Last Datasets Update : {info.datasets.finished} ( {info.datasets.info} new datases added)</i></p>
        <p><i>Last Classes Update :  {info.classes.finished} ( {info.classes.info} new classes added)</i></p>
        <p><i>Last Summaries Update :  {info.summaries.finished} ( {info.summaries.info} new summaries added)</i></p>
        <p><i>Last Recommendation List Update :  {info.recs.finished} ( {info.recs.info}  total recommendations)</i></p>
        <p><a href={`${process.env.REACT_APP_BACKEND_API_URL}/download/dcat`} target="new">Export GeoLOD DCAT</a></p>
      </div>}
      <br/> 

      <h3 >People</h3>
      <hr className="abouthr"/>
      <div className="aboutDiv">
        <p><b>Vasilis Kopsachilis</b></p>
        <p>PhD Candidate</p>
        <p><a href="mailto:vkopsachilis@geo.aegean.gr">vkopsachilis at geo.aegean.gr</a></p>
      <br/>
        <p><b>Michail Vaitis</b></p>
        <p>Associate Professor</p>
        <p><a href="mailto:vaitis@aegean.gr">vaitis at aegean.gr</a></p>
      </div>
      <br/>
      <h3 id="pubs">Related Publications</h3>
      <hr className="abouthr"/>
        <ul>
          <li>Kopsachilis V. (2018) <a href="https://link.springer.com/chapter/10.1007/978-3-319-98192-5_42" target="new">  Recommending Spatial Classes for Entity Interlinking in the Web of Data.</a> In: Gangemi A. et al. (eds) The Semantic Web: ESWC 2018 Satellite Events. ESWC 2018. Lecture Notes in Computer Science, vol 11155. Springer, Cham. https://doi.org/10.1007/978-3-319-98192-5_42</li>
          <li>Kopsachilis V., Vaitis M., Mamoulis N. and Kotzinos D. (2020) <a href="https://doi.org/10.1007/s13740-020-00117-4" target="new">	Recommending Geo-semantically Related Classes for Link Discovery.</a> Journal on Data Semantics, Springer, Cham. https://doi.org/10.1007/s13740-020-00117-4</li>
        </ul>
      <br/>
      <h3 >Funding</h3>
      <hr className="abouthr"/>
      <div className="aboutDiv">  <p>This research supported by the funding program <a href="https://w3.ru.aegean.gr/YPATIA/php/start.php" target="new">”YPATIA”</a> of University of Aegean.</p></div>
      <br/>
      <br/>
      <br/>
  </div>;
};

export default About;